import moment from "moment";
import { getLevels } from "@/config/LevelConstants";

export function dateRange(startDate, endDate) {
  var start = moment(startDate).format("YYYY-MM-DD").split("-");
  var end = moment(endDate).format("YYYY-MM-DD").split("-");
  var startYear = parseInt(start[0]);
  var endYear = parseInt(end[0]);
  var dates = [];

  for (var i = startYear; i <= endYear; i++) {
    var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
    var startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
    for (var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j + 1) {
      var month = j + 1;
      var displayMonth = month < 10 ? "0" + month : month;
      dates.push([i, displayMonth, "01"].join("-"));
    }
  }
  return dates;
}

export function dailyDateRange(startDate, endDate) {
  var start = moment(startDate);
  var end = moment(endDate);
  var dates = [];

  while (start.isSameOrBefore(end)) {
    dates.push(start.format("YYYY-MM-DD"));
    start.add(1, "day");
  }
  return dates;
}
export function getRangeMonthsSY(activeSchoolarYear, schoolarYears) {
  let start, end;
  schoolarYears.forEach((elem) => {
    if (elem._id == activeSchoolarYear) {
      end = elem.end;
      start = elem.start;
    }
  });
  const range = dateRange(
    moment(start).format("YYYY-MM-DD"),
    moment(end).format("YYYY-MM-DD")
  );
  return range;
}
export function getStatus(entry, insc) {
  if (!entry.inscription && insc > 0) return "impayed";
  else {
    if (entry.once == false && entry.months) {
      for (const [key, value] of Object.entries(entry.months)) {
        if (!value) return "impayed";
      }
    }
    return "payed";
  }
}
export function formatFeeName(text, daily = false, t = null) {
  if (moment(text, moment.ISO_8601, true).isValid()) {
    // Check if it's a daily date (has day != 01) or monthly date (day == 01)
    const date = moment(text);
    if (date.format("DD") === "01" && daily == false) {
      // Monthly format
      const month = date.format("MMMM");
      return month.charAt(0).toUpperCase() + month.slice(1);
    } else {
      // Daily format
      // Return daily format with day name in French between parentheses
      return (
        date.format("DD/MM/YYYY") +
        " (" +
        capitalizeFirstLetter(date.format("dddd")) +
        ")"
      );
    }
  } else if (!isNaN(text)) {
    return t ? t("paiement.trancheLabel") + " " + text : "Tranche " + text;
  } else {
    if (text === "inscription" && t) {
      return t("paiement.inscriptionLabel");
    }
    return text; // or handle other cases if needed
  }
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function generatePassword() {
  const length = 8; // Minimum length
  const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lowercase = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";

  // Ensure at least one character from each required set
  const randomUppercase =
    uppercase[Math.floor(Math.random() * uppercase.length)];
  const randomLowercase =
    lowercase[Math.floor(Math.random() * lowercase.length)];
  const randomNumber = numbers[Math.floor(Math.random() * numbers.length)];

  // Combine all character sets and generate the remaining characters randomly
  const allCharacters = uppercase + lowercase + numbers;
  let remainingCharacters = "";
  for (let i = 0; i < length - 3; i++) {
    // 3 characters already added
    remainingCharacters +=
      allCharacters[Math.floor(Math.random() * allCharacters.length)];
  }

  // Shuffle the password to ensure randomness
  const passwordArray = (
    randomUppercase +
    randomLowercase +
    randomNumber +
    remainingCharacters
  )
    .split("")
    .sort(() => Math.random() - 0.5);
  return passwordArray.join("");
}

export function getPaymentMethodColor(method) {
  const colors = {
    ESPESE: "green",
    CHEQUE: "blue",
    TPE: "orange",
    TRAITE: "purple",
    VIREMENT: "teal",
  };
  return colors[method] || "default";
}

/**
 * School year names are stored with their months (e.g. "08-2022/04-2023").
 * Reports only need the years, so keep "2022/2023".
 */
export function shortSchoolarYearName(name) {
  if (!name) return "";
  const years = String(name).match(/\d{4}/g);
  return years && years.length >= 2
    ? `${years[0]}/${years[years.length - 1]}`
    : String(name);
}

export function getSerialColor(record) {
  // Adjust the property if needed
  if (record.typeFR == "F") {
    return "#108ee9";
  }
  return "blue";
}
export function getCancellationColor(type) {
  if (type == "Annulation") {
    return "red";
  }
  return "orange";
}

export function getChequeStatutColor(statut) {
  const colors = {
    // ["VALIDATED", "REJECTED", "PENDING"]
    VALIDATED: "green",
    REJECTED: "red",
    PENDING: "orange",
    REPLACED: "#faad14", // amber: warning + info (Ant Design warning color)
    CANCELLED: "red",
  };
  return colors[statut] || "default";
}

export function getStatutDepotColor(statutDepot) {
  const colors = {
    //["NON_DEPOSE", "DEPOSE", "TRAITE"]
    NON_DEPOSE: "red",
    DEPOSE: "blue",
    TRAITE: "green",
  };
  return colors[statutDepot] || "default";
}

export function getInvoiceStatusColor(status) {
  const colors = {
    active: "green",
    cancelled: "red",
  };
  return colors[status] || "blue";
}

/**
 * Get school type from school details or user/settings
 * @param {Object|Array<string>} schoolDetailsOrType - School details object with type property, or user/settings objects, or school type array directly
 * @param {Object} settings - Settings object with activeBuilding (required if first param is user object)
 * @returns {Array<string>|null} School type(s) as array, or null if not found
 */
export function getSchoolType(schoolDetailsOrType, settings = null) {
  // If it's already an array, return it directly
  if (Array.isArray(schoolDetailsOrType)) {
    return schoolDetailsOrType;
  }

  if (schoolDetailsOrType && schoolDetailsOrType.type) {
    return schoolDetailsOrType.type; // This is an array from the Building model
  }

  if (
    schoolDetailsOrType &&
    schoolDetailsOrType.building &&
    settings &&
    settings.activeBuilding
  ) {
    const building = schoolDetailsOrType.building.find(
      (el) => el.dbName === settings.activeBuilding
    );
    return building ? building.type : null; // This is an array from the Building model
  }

  return null;
}

/**
 * Get available levels for a school type
 * @param {Function} $t - Vue i18n translation function
 * @param {Array<string>} schoolType - Array of school types (jardinEnfant, ecole, college, lycee)
 * @returns {Array} Array of level numbers sorted in ascending order
 */
export function getAvailableLevels($t, schoolType, countryCode = "TN") {
  const levelsObject = getLevels($t, schoolType, countryCode);
  return Object.keys(levelsObject).map((level) => Number(level));
}
